import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      platform: 'platform'
    }),
  },
  methods: {
    toPage(routeInfo) {
      if (this.platform === 'web') {
        const page = this.$router.resolve(routeInfo)
        window.open(page.href, '_blank')
      } else {
        this.$router.push(routeInfo)
      }
    },
  }
}
